/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StatusChallengeRequest
 */
export interface StatusChallengeRequest {
    /**
     * 
     * @type {string}
     * @memberof StatusChallengeRequest
     */
    challengeType: StatusChallengeRequestChallengeTypeEnum;
}


/**
 * @export
 */
export const StatusChallengeRequestChallengeTypeEnum = {
    StatusChallenge0: 'status_challenge_0',
    StatusChallenge1: 'status_challenge_1',
    StatusChallenge2: 'status_challenge_2'
} as const;
export type StatusChallengeRequestChallengeTypeEnum = typeof StatusChallengeRequestChallengeTypeEnum[keyof typeof StatusChallengeRequestChallengeTypeEnum];


/**
 * Check if a given object implements the StatusChallengeRequest interface.
 */
export function instanceOfStatusChallengeRequest(value: object): value is StatusChallengeRequest {
    if (!('challengeType' in value) || value['challengeType'] === undefined) return false;
    return true;
}

export function StatusChallengeRequestFromJSON(json: any): StatusChallengeRequest {
    return StatusChallengeRequestFromJSONTyped(json, false);
}

export function StatusChallengeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): StatusChallengeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'challengeType': json['challenge_type'],
    };
}

export function StatusChallengeRequestToJSON(json: any): StatusChallengeRequest {
    return StatusChallengeRequestToJSONTyped(json, false);
}

export function StatusChallengeRequestToJSONTyped(value?: StatusChallengeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge_type': value['challengeType'],
    };
}

